export default __webpack_public_path__ + "static/media/review_color.2da6a657.svg";